import type { CompleteOnboardingPayload } from './complete-onboarding-payload';


/** Данные визарда, из которых собирается запрос; форму задаёт сама фича, чтобы не зависеть от виджета. */
export type OnboardingWizardData = {
    billing_address?: CompleteOnboardingPayload['billing_address'];
    company?        : CompleteOnboardingPayload['company'];
    plan?           : Pick<CompleteOnboardingPayload, 'billing_period' | 'plan_id'>;
};


/** Собирает запрос из данных визарда; null, если не хватает плана, биллинга или (при `includeCompany`) компании. */
export const buildOnboardingPayload = (
    data: OnboardingWizardData,
    includeCompany: boolean,
): CompleteOnboardingPayload | null => {
    if (!data.plan || !data.billing_address) return null;
    if (includeCompany && !data.company) return null;

    return {
        plan_id        : data.plan.plan_id,
        billing_period : data.plan.billing_period,
        billing_address: data.billing_address,
        ...(includeCompany && data.company ? { company: data.company } : {}),
    };
};
